module.exports = __webpack_public_path__ + "img/red-circle-table-8.42cde162.png";